export default function (controller) {
  $(document).ready(function() {
    setTimeout(function() {
      $('.notice, .alert').not('.fixed').fadeOut();
    }, 3000);
  })
}
